/* import __COLOCATED_TEMPLATE__ from './dropdown-select-box-row.hbs'; */
import { readOnly } from "@ember/object/computed";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
export default SelectKitRowComponent.extend({
  classNames: ["dropdown-select-box-row"],
  description: readOnly("item.description")
});